<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="my-1 mx-3">
        <div class="d-flex align-end">
          <div class="icon-back">
            <v-icon id="icon" size="37" color="white">
              mdi-chart-areaspline
            </v-icon>
          </div>

          <v-toolbar-title class="main-toolbar-title pb-1">
            {{ $t('Agendamentos - Cronograma') }}
          </v-toolbar-title>
        </div>
      </div>
    </div>

    <div class="tabs-container mt-3 mb-3">
      <v-tabs
        v-model="activeTab"
        background-color="transparent"
        color="primary"
        grow
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab
          active-class="activated-tab"
          class="rounded-lg rounded-b-0 tab-button"
          key="sistema"
        >
          <v-icon left small>mdi-message-text</v-icon>
          Cronograma
        </v-tab>

        <v-tab
          key="manuais"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0 tab-button"
        >
          <v-icon left small>mdi-book-open-page-variant</v-icon>
          Planejamentos
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-main id="table" class="back pa-3">
          <v-container>
            <v-row class="ma-0" dense>
              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Instituição') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="institutionId"
                  :items="institutions"
                  item-text="name"
                  item-value="id"
                  :loading="institutionLoading"
                  disabled
                  outlined
                  class="primary-input"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Unidades') }}</label>
                <v-autocomplete
                  :search-input.sync="unitySearch"
                  @blur="unitySearch = ''"
                  hide-details="auto"
                  v-model="unidadeSelected"
                  :items="unidades"
                  item-text="name"
                  :loading="unidadeLoading"
                  :disabled="!institutionId"
                  :placeholder="
                    !institutionId
                      ? $t('Selecione uma instituição')
                      : $t('Todas')
                  "
                  multiple
                  deletable-chips
                  return-object
                  outlined
                  class="primary-input"
                  @change="getDepartments"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeUnidade(item)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Setor') }}</label>
                <v-autocomplete
                  :search-input.sync="departmentSearch"
                  :disabled="unidadeSelected.length == 0"
                  @blur="departmentSearch = ''"
                  hide-details="auto"
                  v-model="departmentSelected"
                  :items="departments"
                  item-text="name"
                  multiple
                  deletable-chips
                  return-object
                  placeholder="Todos"
                  outlined
                  class="primary-input"
                  @change="getSubDepartments"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeDepartment(item)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Subsetor') }}</label>
                <v-autocomplete
                  :search-input.sync="subDepartmentSearch"
                  :disabled="!departmentSelected.length"
                  @blur="subDepartmentSearch = ''"
                  hide-details="auto"
                  v-model="subDepartmentSelected"
                  :items="subDepartments"
                  item-text="name"
                  multiple
                  deletable-chips
                  return-object
                  placeholder="Todos"
                  outlined
                  class="primary-input"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeSubdepartment(item)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Situação') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="equipmentSituation"
                  :items="situations"
                  outlined
                  class="primary-input"
                  @keyup.enter="filterTable"
                >
                  <template v-slot:selection="{ item }">
                    <span class="text-caption">
                      {{ $t(item) }}
                    </span>
                  </template>

                  <template v-slot:item="{ item }">
                    <span class="text-caption">
                      {{ $t(item) }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Equipamento padrão') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  chips
                  clearable
                  v-model="standardEquipmentSelected"
                  :items="standardEquipment"
                  return-object
                  item-text="name"
                  multiple
                  deletable-chips
                  small-chips
                  outlined
                  class="primary-input"
                  placeholder="Todos"
                  :loading="standardEquipmentLoading"
                  :search-input.sync="search"
                  @blur="search = ''"
                >
                  <template v-slot:item="{ item }">
                    {{ item.standardEquipment.name }}
                  </template>
                  <template
                    v-slot:selection="{ attrs, item, index, select, selected }"
                  >
                    <v-chip
                      v-if="index === 0"
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeStandardEquipment(item)"
                    >
                      {{ item.standardEquipment.name }}
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text text-caption"
                      style="font-size: 0.8rem"
                    >
                      ( +{{ standardEquipmentSelected.length - 1 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Identificação') }}</label>
                <v-text-field
                  v-model="identification"
                  hide-details="auto"
                  clearable
                  small-chips
                  outlined
                  class="primary-input"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Código Patrimônio') }}</label>
                <v-text-field
                  v-model="propertyCode"
                  hide-details="auto"
                  clearable
                  small-chips
                  outlined
                  class="primary-input"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <label class="label">{{ $t('Responsável') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="responsible"
                  :items="responsibles"
                  item-text="name"
                  item-value="id"
                  outlined
                  class="primary-input"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <label class="label">{{ $t('Responsabilidade') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="responsibility"
                  :items="responsibilities"
                  outlined
                  class="primary-input"
                ></v-autocomplete>

                <div v-if="responsibility == 'Interna' || responsibility == 0">
                  <v-checkbox
                    hide-details="auto"
                    :label="$t('Equipe Volante')"
                    v-model="internalTeam"
                    outlined
                    class="mt-0 ml-2"
                  ></v-checkbox>
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="3"
                v-if="institution.departmentTypes.includes(1)"
              >
                <label class="label ml-1">{{ $t('Oficina') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="workshopId"
                  :items="workshopTypes"
                  item-text="name"
                  item-value="id"
                  autocomplete="off"
                  outlined
                  class="primary-input"
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <label class="label">{{ $t('Tipo') }}</label>
                <v-autocomplete
                  @blur="typeSearch = ''"
                  :search-input.sync="typeSearch"
                  hide-details="auto"
                  v-model="serviceOrderTypeSelected"
                  :items="serviceOrderTypes"
                  item-text="name"
                  item-value="value"
                  multiple
                  deletable-chips
                  placeholder="Todos"
                  outlined
                  class="primary-input"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeServiceOrderType(item.value)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" lg="3">
                <label class="label">{{ $t('Estado') }}</label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="state"
                  item-text="text"
                  item-value="value"
                  :items="states"
                  outlined
                  multiple
                  class="primary-input"
                >
                  <template
                    v-slot:selection="{ attrs, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeStatus(item)"
                    >
                      {{ item.text }}
                    </v-chip>
                  </template>
                </v-autocomplete>

                <v-checkbox
                  v-model="correctiveMaintenanceEquipment"
                  hide-details
                  label="Equipamentos em Manutenção Corretiva"
                ></v-checkbox>
              </v-col>

              <v-col cols="12" sm="3">
                <v-row no-gutters class="ma-0">
                  <v-col cols="12" class="d-flex justify-center">
                    <label class="label"> {{ $t('Período') }}: </label>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      hide-details="auto"
                      v-model="month"
                      :items="months"
                      outlined
                      :placeholder="$t('Mês')"
                      class="primary-input mr-1"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      hide-details="auto"
                      v-model="year"
                      :items="years"
                      outlined
                      :placeholder="$t('Ano')"
                      class="primary-input"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3">
                <label class="label"> {{ $t('Formato') }}: </label>
                <v-autocomplete
                  hide-details="auto"
                  v-model="format"
                  :items="formats"
                  outlined
                  class="primary-input"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <div class="d-flex align-center justify-center">
                  <v-btn
                    :loading="loading"
                    class="mx-4 primary-button"
                    color="#0F3565"
                    @click="scheduleExport"
                  >
                    <span>Exportar</span>
                    <v-icon class="pl-2">mdi-download</v-icon>
                  </v-btn>
                  <v-btn color="#20202066" class="clear-button" @click="reset">
                    <span>{{ $t('Limpar') }}</span>
                    <v-icon class="pl-2">mdi-cached</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </v-tab-item>

      <v-tab-item>
        <v-main class="back pa-3">
          <v-container>
            <v-row class="ma-0" dense>
              <v-col cols="12">
                <v-row class="ma-0" dense>
                  <v-col cols="12" sm="6" md="4" lg="3">
                    <label class="label">{{ $t('Unidade') }}</label>
                    <v-autocomplete
                      :search-input.sync="planningUnitySearch"
                      @blur="planningUnitySearch = ''"
                      hide-details="auto"
                      v-model="planningUnidadeSelected"
                      :items="unidades"
                      item-text="name"
                      :loading="unidadeLoading"
                      placeholder="Selecione"
                      multiple
                      deletable-chips
                      return-object
                      outlined
                      class="primary-input"
                    >
                      <template
                        v-slot:selection="{ attrs, item, select, selected }"
                      >
                        <v-chip
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          color="#BBCF20"
                          text-color="#fff"
                          small
                          @click="select"
                          @click:close="removePlanningUnidade(item)"
                        >
                          {{ item.name }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3">
                    <label class="label">{{ $t('Equipamento padrão') }}</label>
                    <v-autocomplete
                      hide-details="auto"
                      chips
                      clearable
                      v-model="planningStandardEquipmentSelected"
                      :items="standardEquipment"
                      return-object
                      item-text="name"
                      multiple
                      deletable-chips
                      small-chips
                      outlined
                      class="primary-input"
                      placeholder="Selecione"
                      :loading="standardEquipmentLoading"
                      :search-input.sync="planningStandardSearch"
                      @blur="planningStandardSearch = ''"
                    >
                      <template v-slot:item="{ item }">
                        {{ item.standardEquipment.name }}
                      </template>
                      <template
                        v-slot:selection="{
                          attrs,
                          item,
                          index,
                          select,
                          selected,
                        }"
                      >
                        <v-chip
                          v-if="index === 0"
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          color="#BBCF20"
                          text-color="#fff"
                          small
                          @click="select"
                          @click:close="removePlanningStandardEquipment(item)"
                        >
                          {{ item.standardEquipment.name }}
                        </v-chip>
                        <span
                          v-if="index === 1"
                          class="grey--text text-caption"
                          style="font-size: 0.8rem"
                        >
                          ( +{{ planningStandardEquipmentSelected.length - 1 }})
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3">
                    <label class="label">{{ $t('Pendências') }}</label>
                    <v-autocomplete
                      hide-details="auto"
                      v-model="planningPendencies"
                      :items="pendenciesOptions"
                      item-text="text"
                      item-value="value"
                      outlined
                      placeholder="Selecione"
                      class="primary-input"
                    >
                      <template v-slot:selection="{ item }">
                        <span class="text-caption">
                          {{ $t(item.text) }}
                        </span>
                      </template>

                      <template v-slot:item="{ item }">
                        <span class="text-caption">
                          {{ $t(item.text) }}
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" lg="3">
                    <label class="label"
                      >{{ $t('Tipo O.S') }}
                      <span style="color: red">*</span></label
                    >
                    <v-autocomplete
                      hide-details="auto"
                      v-model="planningServiceOrderTypeSelected"
                      :items="serviceOrderTypes.slice(1, 5)"
                      item-text="name"
                      item-value="value"
                      :rules="[(v) => v !== null || 'Tipo O.S obrigatório']"
                      placeholder="Selecione"
                      outlined
                      clearable
                      class="primary-input"
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <label class="label">{{ $t('Fechamento da O.S') }}</label>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-menu
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          class="primary-input"
                          placeholder="Inicial"
                          :value="formatDateTime(planningCloseDateStart)"
                          prepend-inner-icon="mdi-calendar"
                          hide-details="auto"
                          outlined
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable
                          @click:clear="planningCloseDateStart = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt"
                        v-model="planningCloseDateStart"
                        no-title
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-menu
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          class="primary-input"
                          placeholder="Final"
                          :value="formatDateTime(planningCloseDateEnd)"
                          prepend-inner-icon="mdi-calendar"
                          hide-details="auto"
                          outlined
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!planningCloseDateStart"
                          clearable
                          @click:clear="planningCloseDateEnd = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt"
                        v-model="planningCloseDateEnd"
                        no-title
                        :min="planningCloseDateStart"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn
                      v-if="planningSelected.length > 0"
                      class="primary-button mr-2"
                      color="#BBCF20"
                      depressed
                      @click="openSendDialog"
                    >
                      <v-icon left>mdi-send</v-icon>
                      <span
                        >Atribuir ({{
                          planningSelected.length
                        }}
                        selecionados)</span
                      >
                    </v-btn>

                    <v-btn
                      class="secondary-button mr-2"
                      depressed
                      :loading="loading"
                      @click="planAll"
                    >
                      <span>{{
                        planningSelected.length > 0
                          ? 'Atualizar agendamentos selecionados'
                          : 'Atualizar agendamentos'
                      }}</span>
                    </v-btn>

                    <v-btn
                      class="clear-button mr-2"
                      depressed
                      @click="resetPlanningFilters"
                    >
                      {{ $t('Limpar') }}
                    </v-btn>
                    <v-btn
                      class="secondary-button"
                      depressed
                      @click="applyPlanningFilters"
                    >
                      {{ $t('Aplicar filtros') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" class="mt-4">
                <div class="d-flex justify-end mb-2">
                  <v-menu
                    v-model="headMenu"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        style="
                          display: inline-block;
                          width: 1px;
                          height: 1px;
                          opacity: 0;
                          position: absolute;
                        "
                        tabindex="0"
                      ></span>
                    </template>

                    <v-card style="max-height: 500px" class="overflow-y-auto">
                      <v-list>
                        <v-list-item>
                          <strong>{{ $t('Colunas da tabela') }}:</strong>
                        </v-list-item>

                        <v-list-item>
                          <strong>{{ $t('Ativos') }}</strong>
                        </v-list-item>

                        <v-list-item
                          v-if="
                            planningHeaders.filter(
                              (x) => x.active && x.text != 'Ações'
                            ).length == 0
                          "
                        >
                          {{ $t('Sem registros') }}
                        </v-list-item>

                        <v-list-item
                          v-for="header in planningHeaders.filter(
                            (x) => x.active && x.text != 'Ações'
                          )"
                          :key="header.value"
                        >
                          <v-list-item-action>
                            <v-switch
                              v-model="header.active"
                              inset
                              color="#BBCF20"
                            ></v-switch>
                          </v-list-item-action>
                          <v-list-item-title>{{
                            $t(header.text)
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>

                      <v-divider></v-divider>

                      <v-list>
                        <v-list-item>
                          <strong>{{ $t('Inativos') }}</strong>
                        </v-list-item>

                        <v-list-item
                          v-if="
                            planningHeaders.filter((x) => !x.active).length == 0
                          "
                        >
                          {{ $t('Sem registros') }}
                        </v-list-item>

                        <v-list-item
                          v-for="header in planningHeaders.filter(
                            (x) => !x.active
                          )"
                          :key="header.value"
                        >
                          <v-list-item-action>
                            <v-switch
                              v-model="header.active"
                              inset
                              color="#BBCF20"
                            ></v-switch>
                          </v-list-item-action>
                          <v-list-item-title>{{
                            $t(header.text)
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>

                      <v-card-actions
                        class="white"
                        style="position: sticky; bottom: 0"
                      >
                        <v-spacer></v-spacer>

                        <v-btn text @click="headMenu = false"> Cancelar </v-btn>
                        <v-btn
                          :loading="menuLoading"
                          class="ma-1 primary-button"
                          text
                          @click="updateHeaders"
                        >
                          {{ $t('Salvar no usuário') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </div>

                <v-data-table
                  :headers="planningHeaders.filter((x) => x.active)"
                  :items="planningItems"
                  v-model="planningSelected"
                  :single-select="false"
                  item-key="planningId"
                  show-select
                  :items-per-page="planningFilter.pageSize"
                  class="main-table"
                  hide-default-footer
                  hide-default-header
                  mobile-breakpoint="0"
                  :loading="planningLoading"
                  no-data-text="Utilize o filtro acima para mostrar os dados"
                >
                  <template #header="{ props, on }">
                    <thead>
                      <tr>
                        <th
                          class="text-center"
                          v-for="header in props.headers"
                          :key="header.value"
                        >
                          <v-simple-checkbox
                            v-if="header.value === 'data-table-select'"
                            v-model="props.everyItem"
                            :indeterminate="props.someItems && !props.everyItem"
                            color="purple"
                            @input="on['toggle-select-all']"
                          ></v-simple-checkbox>

                          <div
                            v-if="header.value === 'actions'"
                            class="d-flex align-center justify-center"
                            style="position: relative"
                          >
                            <span class="flex-grow-1 text-center">{{
                              $t(header.text)
                            }}</span>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  dark
                                  class="ma-1 mr-3"
                                  style="margin-left: 8px; cursor: pointer"
                                  @click="headMenu = true"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-pencil-outline
                                </v-icon>
                              </template>
                              <span>{{ $t('Customizar colunas') }}</span>
                            </v-tooltip>
                          </div>

                          <div v-else>
                            <v-hover v-slot="{ hover }">
                              <div>
                                <span>{{ $t(header.text) }}</span>
                                <v-icon
                                  v-if="hover && header.value != 'actions'"
                                  color="white"
                                  class="mx-2"
                                  @click="on.sort(header.value)"
                                >
                                  {{
                                    props.options.sortBy.includes(header.value)
                                      ? `mdi-chevron-down`
                                      : `mdi-chevron-up`
                                  }}
                                </v-icon>
                              </div>
                            </v-hover>
                          </div>
                        </th>
                      </tr>
                    </thead>
                  </template>

                  <template #[`item.serviceOrderType`]="{ item }">
                    {{
                      item.serviceOrderType !== null &&
                      item.serviceOrderType !== undefined
                        ? serviceOrderTypes.find(
                            (x) => x.value === item.serviceOrderType
                          )?.name || '-'
                        : '-'
                    }}
                  </template>

                  <template #[`item.equipmentId`]="{ item }">
                    {{ item.equipmentId || '-' }}
                  </template>

                  <template #[`item.standardEquipment`]="{ item }">
                    {{ item.standardEquipment || '-' }}
                  </template>

                  <template #[`item.manufacturer`]="{ item }">
                    {{ item.manufacturer || '-' }}
                  </template>

                  <template #[`item.serialNumber`]="{ item }">
                    {{ item.serialNumber || '-' }}
                  </template>

                  <template #[`item.propertyCode`]="{ item }">
                    {{ item.propertyCode || '-' }}
                  </template>

                  <template #[`item.lastMaintenance`]="{ item }">
                    <strong>
                      {{
                        item.lastMaintenance
                          ? formatDateTime(item.lastMaintenance)
                          : '-'
                      }}
                    </strong>
                  </template>

                  <template #[`item.nextMaintenance`]="{ item }">
                    <span v-if="item.hasPendencies"> A definir </span>
                    <strong
                      v-else-if="item.nextMaintenance"
                      :style="getMaintenanceColor(item)"
                    >
                      {{ formatDateTime(item.nextMaintenance) }}
                    </strong>
                    <span v-else> A definir </span>
                  </template>

                  <template #[`item.osRequester`]="{ item }">
                    {{ item.osInfo ? item.osInfo.requester : '-' }}
                  </template>

                  <template #[`item.osResponsible`]="{ item }">
                    {{
                      item.osInfo
                        ? getResponsibleName(item.osInfo.responsibleId)
                        : '-'
                    }}
                  </template>

                  <template #[`item.osResponsibility`]="{ item }">
                    {{
                      item.osInfo
                        ? getResponsibilityText(item.osInfo.responsability)
                        : '-'
                    }}
                  </template>

                  <template #[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          class="ma-1"
                          color="#0F3565"
                          dark
                          small
                          depressed
                          @click="edit(item)"
                          v-on="on"
                        >
                          <v-icon size="22">mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('Editar') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          class="ma-1"
                          color="#921616"
                          dark
                          depressed
                          small
                          @click="openDelete(item)"
                          v-on="on"
                        >
                          <v-icon size="22">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('Excluir') }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>

                <div class="pagination mx-2">
                  <div class="item-pagination block-one">
                    <v-menu bottom offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn"
                          depressed
                          color="#C0C0C0"
                          small
                        >
                          qtd: {{ planningFilter.pageSize }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(size, i) in sizes"
                          :key="i"
                          @click="planningFilter.pageSize = size"
                        >
                          <v-list-item-title>{{ size }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div class="registros" v-if="planningItems.length">
                      <span>
                        1 - {{ planningItems.length }} de
                        {{ planningFilter.totalItems }}
                      </span>
                      <br />
                    </div>
                  </div>

                  <div class="item-pagination block-two">
                    <v-pagination
                      class="pagination-item"
                      v-model="planningFilter.page"
                      :length="planningFilter.totalPages"
                      :total-visible="5"
                    ></v-pagination>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="showEditModal" max-width="480" persistent>
      <v-card>
        <v-card-title class="main-toolbar">
          <span class="main-toolbar-title mb-7">{{
            $t('Editar Planejamento')
          }}</span>
          <v-divider class="mt-4"></v-divider>
        </v-card-title>

        <div class="ma-4">
          <v-row class="ma-0">
            <v-col cols="6">
              <label class="label">{{ $t('Última manutenção') }}</label>
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="primary-input"
                    :value="formatDateTime(editItem.lastMaintenance)"
                    prepend-inner-icon="mdi-calendar"
                    hide-details="auto"
                    outlined
                    readonly
                    disabled
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="editItem.lastMaintenance = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="pt"
                  v-model="editItem.lastMaintenance"
                  no-title
                >
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6">
              <label class="label">{{ $t('Próxima manutenção') }}</label>
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="primary-input"
                    :value="formatDateTime(editItem.nextMaintenance)"
                    prepend-inner-icon="mdi-calendar"
                    hide-details="auto"
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="editItem.nextMaintenance = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="pt"
                  v-model="editItem.nextMaintenance"
                  no-title
                  :min="nextMaintenanceMinDate"
                >
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" class="py-0">
              <label class="label">
                {{ 'Periodicidade: ' }}
                <strong>
                  {{ getPeriodicityName(editItem.periodicity) }}
                </strong>
              </label>
            </v-col>
          </v-row>
        </div>

        <v-card-actions class="px-6 pb-6">
          <v-btn
            class="primary-button"
            color="error"
            depressed
            @click="showEditModal = false"
            :loading="editLoading"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="primary-button mr-0"
            depressed
            @click="updateMaintenance"
            :loading="editLoading"
          >
            {{ $t('Atualizar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" :key="deleteKey" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir o item') }}
            {{ currentItem.standardEquipment }}?
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <!-- Diálogo para Enviar Informações da OS -->
    <v-dialog v-model="showSendDialog" max-width="600" persistent>
      <v-card>
        <v-card-title class="main-toolbar">
          <span class="main-toolbar-title mb-7">
            Informações da Ordem de Serviço
          </span>
          <v-divider class="mt-4"></v-divider>
        </v-card-title>

        <div class="ma-4">
          <v-row class="ma-0">
            <v-col cols="12">
              <label class="label">
                Nome da OS <span style="color: red">*</span>
              </label>
              <v-text-field
                v-model="osInfo.serviceOrderName"
                hide-details="auto"
                outlined
                class="primary-input"
                placeholder="Digite o nome da OS"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <label class="label">
                Responsável <span style="color: red">*</span>
              </label>
              <v-autocomplete
                v-model="osInfo.responsibleId"
                :items="responsibles"
                item-text="name"
                item-value="id"
                hide-details="auto"
                outlined
                class="primary-input"
                placeholder="Selecione o responsável"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
              <label class="label">
                Responsabilidade <span style="color: red">*</span>
              </label>
              <v-autocomplete
                v-model="osInfo.responsability"
                :items="responsibilityOptions"
                item-text="text"
                item-value="value"
                hide-details="auto"
                outlined
                class="primary-input"
                placeholder="Selecione a responsabilidade"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <label class="label">
                Solicitante <span style="color: red">*</span>
              </label>
              <v-text-field
                v-model="osInfo.requester"
                hide-details="auto"
                outlined
                class="primary-input"
                placeholder="Digite o nome do solicitante"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <label class="label">
                Solicitação/Reclamação <span style="color: red">*</span>
              </label>
              <v-textarea
                v-model="osInfo.requestDescription"
                hide-details="auto"
                outlined
                rows="3"
                class="primary-input"
                placeholder="Descreva a solicitação ou reclamação"
              ></v-textarea>
            </v-col>
          </v-row>
        </div>

        <v-card-actions class="px-6 pb-6">
          <v-btn
            class="primary-button"
            color="error"
            depressed
            @click="closeSendDialog"
            :disabled="sendLoading"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="primary-button mr-0"
            color="#BBCF20"
            depressed
            @click="saveOsInfo"
            :loading="sendLoading"
          >
            {{ $t('Salvar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para Visualizar Detalhes da OS -->
    <v-dialog v-model="showDetailsDialog" max-width="800" scrollable>
      <v-card>
        <v-container
          style="background: #f5f5f5; overflow-y: auto; max-height: 80vh"
        >
          <div
            id="header"
            class="mt-3 px-3 d-flex justify-space-between align-center"
          >
            <h2>Detalhes da Ordem de Serviço</h2>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ma-1"
                    color="error"
                    depressed
                    dark
                    @click="confirmDeleteOsInfo"
                    v-bind="attrs"
                    v-on="on"
                    :loading="deleteLoading"
                    small
                  >
                    <v-icon small> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Excluir</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ma-1"
                    color="#0F3565"
                    depressed
                    dark
                    @click="showDetailsDialog = false"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon small> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Fechar</span>
              </v-tooltip>
            </div>
          </div>

          <v-divider class="my-3"></v-divider>

          <div v-if="selectedItemDetails">
            <v-row class="ma-0">
              <v-col class="py-0" cols="12">
                <p>
                  <strong class="field mt-6">Nome da OS:</strong>
                  {{
                    selectedItemDetails.osInfo.serviceOrderName ||
                    'Sem registro'
                  }}
                </p>
              </v-col>
            </v-row>

            <v-divider class="my-3"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12">
                <h3>Dados de Responsabilidade</h3>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
                <p>
                  <strong class="field">Responsável:</strong>
                  {{
                    getResponsibleName(
                      selectedItemDetails.osInfo.responsibleId
                    ) || 'Sem registro'
                  }}
                </p>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
                <p>
                  <strong class="field">Responsabilidade:</strong>
                  {{
                    getResponsibilityText(
                      selectedItemDetails.osInfo.responsability
                    ) || 'Sem registro'
                  }}
                </p>
              </v-col>
            </v-row>

            <v-divider class="my-3"></v-divider>

            <v-row class="ma-0">
              <v-col cols="12">
                <h3>Dados da Solicitação</h3>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
                <p>
                  <strong class="field">Solicitante:</strong>
                  {{ selectedItemDetails.osInfo.requester || 'Sem registro' }}
                </p>
              </v-col>
              <v-col class="py-0" cols="12">
                <p class="mb-0">
                  <strong class="field">Solicitação/Reclamação:</strong>
                </p>
                <p>
                  {{
                    selectedItemDetails.osInfo.requestDescription ||
                    'Sem registro'
                  }}
                </p>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import GeneralService from '../../../services/GeneralService'

export default {
  name: 'ChronogramPage',
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.getInstitutions()
    this.getStandardEquipment()
    this.getWorkshops()
    this.getresponsibles()

    if (this.institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    if (this.institution.userType == 5) {
      this.unidadeSelected = this.unidades.filter(
        (x) => x.id === this.userLogged.unidadeId
      )
      this.getDepartments()
    }

    const currentYear = new Date().getFullYear()
    this.years.unshift(currentYear)

    for (let i = 0; i < 3; i++) {
      const year = currentYear - i
      this.years.unshift(year)
    }

    for (let i = 0; i < 3; i++) {
      const year = currentYear + i
      this.years.push(year)
    }

    this.year = currentYear

    this.format = this.formats[0]

    const columns = JSON.parse(this.userLogged.chronogramColumns || null)
    if (columns) {
      this.planningHeaders = this.planningHeaders.map((x) => {
        const find = columns.find((y) => y.text == x.text)
        if (find) {
          return find
        } else {
          return x
        }
      })
    }
  },

  computed: {
    nextMaintenanceMinDate() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      today.setDate(today.getDate() + 1)
      return today.toISOString().split('T')[0]
    },
  },

  data: () => ({
    activeTab: 0,
    correctiveMaintenanceEquipment: false,
    workshopId: null,
    workshopTypes: [],
    institution: {},
    typeSearch: '',
    departmentSearch: '',
    subDepartmentSearch: '',
    departmentIds: [],
    unitySearch: '',
    identification: '',
    propertyCode: '',
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    standardEquipmentLoading: false,
    menu: false,
    date: null,
    month: null,
    year: null,
    format: null,
    internalTeam: null,
    responsibility: null,
    responsible: null,
    institutionId: null,
    search: null,
    institutions: [],
    unidadeSelected: [],
    state: null,
    states: [
      { text: 'Agendada', value: 0 },
      { text: 'Executada dentro do prazo', value: 1 },
      { text: 'Executada fora do prazo', value: 2 },
      { text: 'Atrasada', value: 3 },
    ],
    unidades: [],
    standardEquipmentSelected: [],
    standardEquipment: [],
    departmentSelected: [],
    subDepartmentSelected: [],
    departments: [],
    subDepartments: [],
    serviceOrderTypeSelected: [],
    userLogged: {},
    apiService: new ApiService(),
    generalService: new GeneralService(),
    equipmentSituation: null,
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
      'Convênio',
    ],
    serviceOrderTypes: [
      {
        name: 'Treinamento',
        value: 0,
      },
      {
        name: 'Segurança elétrica',
        value: 1,
      },
      {
        name: 'Preventiva',
        value: 2,
      },
      {
        name: 'Calibração',
        value: 6,
      },
      {
        name: 'Validação/Qualificação',
        value: 7,
      },
    ],
    responsibilities: ['Interna', 'Externa'],
    responsibilityOptions: [
      { text: 'Interna', value: 'Interna' },
      { text: 'Externa', value: 'Externa' },
    ],
    responsibles: [],
    months: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    years: [],
    formats: ['HTML', 'Excel', 'PDF'],
    showPlanningFilters: false,
    planningPanel: 0,
    planningUnitySearch: '',
    planningUnidadeSelected: [],
    planningStandardSearch: '',
    planningStandardEquipmentSelected: [],
    planningPendencies: null,
    planningTypeSearch: '',
    planningServiceOrderTypeSelected: null,
    planningCloseDateStart: null,
    planningCloseDateEnd: null,
    pendenciesOptions: [
      { text: 'Todas', value: null },
      { text: 'Com pendências', value: true },
      { text: 'Sem pendências', value: false },
    ],

    headMenu: false,
    menuLoading: false,
    planningLoading: false,
    planningItems: [],
    planningSelected: [],
    sizes: [10, 30, 90, 180],
    planningFilter: {
      page: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 0,
    },
    planningHeaders: [
      {
        text: 'Procedimento',
        align: 'center',
        value: 'serviceOrderType',
        active: true,
      },
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'equipmentId',
        active: true,
      },
      {
        text: 'E. Padrão',
        align: 'center',
        value: 'standardEquipment',
        active: true,
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'manufacturer',
        active: true,
      },
      {
        text: 'Número de série',
        align: 'center',
        value: 'serialNumber',
        active: false,
      },
      {
        text: 'Código de Patrimônio',
        align: 'center',
        value: 'propertyCode',
        active: true,
      },
      {
        text: 'Última manutenção',
        align: 'center',
        value: 'lastMaintenance',
        active: true,
      },
      {
        text: 'Próxima manutenção',
        align: 'center',
        value: 'nextMaintenance',
        active: true,
      },
      {
        text: 'Solicitante',
        align: 'center',
        value: 'osRequester',
        active: false,
      },
      {
        text: 'Responsável OS',
        align: 'center',
        value: 'osResponsible',
        active: false,
      },
      {
        text: 'Responsabilidade',
        align: 'center',
        value: 'osResponsibility',
        active: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        active: true,
      },
    ],
    showEditModal: false,
    editLoading: false,
    editItem: {
      planningId: null,
      equipmentId: null,
      serviceOrderType: null,
      standardEquipment: null,
      manufacturer: null,
      serialNumber: null,
      propertyCode: null,
      lastMaintenance: null,
      nextMaintenance: null,
      periodicity: null,
    },
    deleteDialog: false,
    deleteKey: 0,
    currentItem: {},
    periodicities: [
      { text: 'Mensal', value: 0 },
      { text: 'Bimestral', value: 1 },
      { text: 'Trimestral', value: 2 },
      { text: 'Semestral', value: 3 },
      { text: 'Anual', value: 4 },
      { text: 'Bianual', value: 5 },
    ],
    showSendDialog: false,
    sendLoading: false,
    deleteLoading: false,
    osInfo: {
      serviceOrderName: '',
      responsibleId: null,
      requester: '',
      responsability: '',
      requestDescription: '',
    },
    showDetailsDialog: false,
    selectedItemDetails: null,
  }),

  components: {},

  methods: {
    getMaintenanceColor(item) {
      if (this.colorSet(item.nextMaintenance)) {
        return 'color: red'
      }
      if (!item.dateInRightPeriodicity) {
        return 'color: red'
      }
      return 'color: green'
    },
    getMonthsByPeriodicity(periodicity) {
      const periodicityMonths = {
        0: 1,
        1: 2,
        2: 3,
        3: 6,
        4: 12,
        5: 24,
      }
      return periodicityMonths[periodicity] ?? null
    },

    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    getresponsibles() {
      this.apiService
        .get(`user/byType/${this.institutionId}`)
        .then((response) => {
          this.responsibles = response.content
        })
    },

    removeUnidade(item) {
      this.unidadeSelected.splice(this.unidadeSelected.indexOf(item), 1)
      this.unidadeSelected = [...this.unidadeSelected]
    },

    removePlanningUnidade(item) {
      this.planningUnidadeSelected.splice(
        this.planningUnidadeSelected.indexOf(item),
        1
      )
      this.planningUnidadeSelected = [...this.planningUnidadeSelected]
    },

    removeStandardEquipment(item) {
      this.standardEquipmentSelected.splice(
        this.standardEquipmentSelected.indexOf(item),
        1
      )
      this.standardEquipmentSelected = [...this.standardEquipmentSelected]
    },

    removePlanningStandardEquipment(item) {
      this.planningStandardEquipmentSelected.splice(
        this.planningStandardEquipmentSelected.indexOf(item),
        1
      )
      this.planningStandardEquipmentSelected = [
        ...this.planningStandardEquipmentSelected,
      ]
    },

    removeServiceOrderType(item) {
      this.serviceOrderTypeSelected.splice(
        this.serviceOrderTypeSelected.indexOf(item),
        1
      )
      this.serviceOrderTypeSelected = [...this.serviceOrderTypeSelected]
    },

    removeStatus(item) {
      this.state.splice(this.state.indexOf(item), 1)
      this.state = [...this.state]
    },

    removeDepartment(item) {
      this.departmentSelected.splice(this.departmentSelected.indexOf(item), 1)
      this.departmentSelected = [...this.departmentSelected]
    },

    removeSubdepartment(item) {
      this.subDepartmentSelected.splice(
        this.subDepartmentSelected.indexOf(item),
        1
      )
      this.subDepartmentSelected = [...this.subDepartmentSelected]
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipment =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .post(
          `department/list/unidades`,
          this.unidadeSelected.map((x) => x.id)
        )
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },

    async getSubDepartments() {
      if (!this.departmentSelected.length) {
        this.subDepartments = []
        return
      }
      const departmentIds = this.departmentSelected.map((dep) => dep.id)
      this.subDepartments = []

      for (let id of departmentIds) {
        await this.apiService
          .get(`department/list-subdepartment/${id}`)
          .then((response) => {
            this.subDepartments = [...this.subDepartments, ...response.content]
          })
      }
    },

    async scheduleExport() {
      this.loading = true

      const types = this.serviceOrderTypeSelected

      const filter = {
        internalTeam: this.internalTeam,
        idEquipment: this.identification,
        propertyCode: this.propertyCode,
        InstitutionId: this.institutionId,
        Unidades: this.unidadeSelected,
        StandardEquipment: this.standardEquipmentSelected,
        ServiceOrderTypes: types,
        Departments: this.departmentSelected,
        Month: this.months.indexOf(this.month) + 1,
        Year: this.year,
        ExportType: this.format == 'HTML' ? 'Front' : this.format,
        Responsibility:
          this.responsibility != null
            ? this.responsibilities.indexOf(this.responsibility)
            : null,
        Responsible: this.responsible,
        BaseUrl: window.location.origin,
        ChronogramStatus: this.correctiveMaintenanceEquipment
          ? this.state
            ? [...this.state, 4]
            : [4]
          : this.state,
        situation: this.situations.indexOf(this.equipmentSituation),
        workshopId: this.workshopId,
      }

      if (filter.Responsibility == 1) filter.internalTeam = null

      await this.apiService
        .post('Chronogram', filter)
        .then((response) => {
          filter.ExportType = 'HTML'
          localStorage.setItem('scheduleFilters', JSON.stringify(filter))
          window.open('/schedule', '_blank')

          if (this.format == 'PDF') {
            var pdfResult =
              'data:application/pdf;base64,' + response.content.pdf
            const link = document.createElement('a')
            link.href = pdfResult
            link.setAttribute('download', `Cronograma ${this.year}`)
            document.body.appendChild(link)
            link.click()
          }

          if (this.format == 'Excel') {
            var excelResult = `data:application/octet-stream;base64,${response.content.excel}`
            const link = document.createElement('a')
            link.href = excelResult
            link.setAttribute('download', `Cronograma ${this.year}.xlsx`)
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {})

      this.loading = false
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeSelected = this.unidades.filter(
          (x) => x.id === this.userLogged.unidadeId
        )
      } else {
        this.unidadeSelected = []
      }

      this.internalTeam = null
      this.standardEquipmentSelected = []
      this.state = null
      this.serviceOrderTypeSelected = []
      this.departmentSelected = []
      this.month = null
      this.year = new Date().getFullYear()
      this.format = this.formats[0]
      this.responsibility = null
      this.responsible = null
    },

    resetPlanningFilters() {
      this.planningUnidadeSelected = []
      this.planningStandardEquipmentSelected = []
      this.planningPendencies = null
      this.planningServiceOrderTypeSelected = null
      this.planningCloseDateStart = null
      this.planningCloseDateEnd = null
    },

    applyPlanningFilters() {
      if (this.planningServiceOrderTypeSelected === null) {
        this.$toast.error('Por favor, selecione um Tipo O.S')
        this.planningItems = []
        this.planningFilter.totalItems = 0
        this.planningFilter.totalPages = 0
        return
      }
      this.planningFilter.page = 1
      this.getPlanningData()
    },

    async getPlanningData() {
      if (this.planningServiceOrderTypeSelected === null) {
        this.$toast.error('Por favor, selecione um Tipo O.S')
        this.planningItems = []
        this.planningFilter.totalItems = 0
        this.planningFilter.totalPages = 0
        this.planningLoading = false
        return
      }

      this.planningLoading = true

      const serviceOrderTypes = [this.planningServiceOrderTypeSelected]

      const filter = {
        institutionId: this.institutionId,
        unidadeIds: this.planningUnidadeSelected.map((u) => u.id),
        standardEquipmentIds: this.planningStandardEquipmentSelected.map(
          (s) => s.id
        ),
        hasPendencies: this.planningPendencies,
        serviceOrderTypes: serviceOrderTypes,
        closeDateStart: this.planningCloseDateStart,
        closeDateEnd: this.planningCloseDateEnd,
        page: this.planningFilter.page,
        pageSize: this.planningFilter.pageSize,
      }

      try {
        const response = await this.apiService.post(
          'equipment/planning/list',
          filter
        )

        if (response.statusCode === 200) {
          console.log('Dados de planejamento recebidos:', response.content)
          this.planningItems = response.content.items
          this.planningFilter.totalItems = response.content.pager.totalItems
          this.planningFilter.totalPages = response.content.pager.totalPages
        }
      } catch (error) {
        console.error('Erro ao buscar planejamentos:', error)
      } finally {
        this.planningLoading = false
      }
    },

    edit(item) {
      this.editItem = {
        ...item,
        planningId: item.planningId,
        equipmentId: item.id,
        serviceOrderType: item.serviceOrderType,
        lastMaintenance: item.lastMaintenance || null,
        nextMaintenance: item.nextMaintenance || null,
        periodicity: item.periodicity ?? null,
      }
      
      this.showEditModal = true
    },

    closeEditModal() {
      this.showEditModal = false
      this.editItem = {
        planningId: null,
        equipmentId: null,
        serviceOrderType: null,
        standardEquipment: null,
        manufacturer: null,
        serialNumber: null,
        propertyCode: null,
        lastMaintenance: null,
        nextMaintenance: null,
        periodicity: null,
      }
    },

    async addMaintenance() {
      this.editLoading = true
    },

    async planAll() {
      if (this.planningServiceOrderTypeSelected === null) {
        this.$toast.error('Por favor, selecione um Tipo O.S')
        this.planningItems = []
        this.planningFilter.totalItems = 0
        this.planningFilter.totalPages = 0
        return
      }

      this.loading = true
      await this.apiService
        .post(`equipment/planning/plan-all`, {
          institutionId: this.institutionId,
          serviceOrderType: this.planningServiceOrderTypeSelected,
          equipmentIds: this.planningSelected.map((x) => x.id),
        })
        .then(() => {
          this.getPlanningData()
          this.planningSelected = []
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
        })
    },

    async updateMaintenance() {
      if (!this.editItem.nextMaintenance) {
        this.$toast.error('Por favor, selecione a data da próxima manutenção')
        return
      }

      this.editLoading = true

      try {
        await this.apiService
          .post(`equipment/planning/update`, {
            planningId: this.editItem.planningId,
            equipmentId: this.editItem.equipmentId,
            date: this.editItem.nextMaintenance,
            serviceOrderType: this.editItem.serviceOrderType,
          })
          .then(() => {
            this.$toast.success('Manutenção atualizada com sucesso!')
            this.closeEditModal()
            this.getPlanningData()
          })
      } catch (error) {
        console.error('Erro ao atualizar manutenção:', error)
        this.$toast.error('Erro ao atualizar manutenção')
      } finally {
        this.editLoading = false
      }
    },

    openDelete(item) {
      this.currentItem = item
      this.deleteKey++
      this.deleteDialog = true
    },

    async remove() {
      this.loading = true

      try {
        await this.apiService
          .delete(`equipment/planning/delete?planningId=${this.currentItem.planningId}`)
          .then(() => {
            this.$toast.success('Planejamento removido com sucesso!')
            this.deleteDialog = false
            this.currentItem = {}
            this.getPlanningData()
          })
      } catch (error) {
        console.error('Erro ao remover planejamento:', error)
        this.$toast.error('Erro ao remover planejamento')
      } finally {
        this.loading = false
      }
    },

    getPeriodicityName(value) {
      if (value === null || value === undefined)
        return 'Sem periodo de manutenção definido'
      const periodicity = this.periodicities.find((p) => p.value === value)
      return periodicity ? periodicity.text : '-'
    },

    colorSet(dateTime) {
      if (!dateTime) return false
      const date = new Date(dateTime)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      date.setHours(0, 0, 0, 0)
      return date < today
    },

    formatDateTime(dateTime) {
      if (!dateTime) return ''
      const isDateOnly =
        typeof dateTime === 'string' &&
        !dateTime.includes('T') &&
        !dateTime.includes(':')

      const date = new Date(dateTime)

      if (isDateOnly) {
        const day = String(date.getUTCDate()).padStart(2, '0')
        const month = String(date.getUTCMonth() + 1).padStart(2, '0')
        const year = date.getUTCFullYear()
        return `${day}/${month}/${year}`
      }

      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },

    updateHeaders() {
      this.menuLoading = true

      const json = JSON.stringify(this.planningHeaders)
      this.apiService
        .post('user/saveColumns/chronogram', { columns: json })
        .then(() => {
          this.userLogged.chronogramColumns = json

          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))
          this.$toast.success('Configuração salva no seu usuário!')

          this.headMenu = false
          this.menuLoading = false
        })
        .catch(() => {
          this.menuLoading = false
        })
    },

    openSendDialog() {
      if (this.planningSelected.length === 0) {
        this.$toast.error('Selecione pelo menos um agendamento')
        return
      }

      const firstItemWithOsInfo = this.planningSelected.find(
        (item) => item.osInfo
      )

      if (firstItemWithOsInfo && firstItemWithOsInfo.osInfo) {
        this.osInfo = {
          serviceOrderName: firstItemWithOsInfo.osInfo.serviceOrderName || '',
          responsibleId: firstItemWithOsInfo.osInfo.responsibleId || null,
          requester: firstItemWithOsInfo.osInfo.requester || '',
          responsability:
            firstItemWithOsInfo.osInfo.responsability !== undefined
              ? firstItemWithOsInfo.osInfo.responsability
              : null,
          requestDescription:
            firstItemWithOsInfo.osInfo.requestDescription || '',
        }
      } else {
        this.osInfo = {
          serviceOrderName: '',
          responsibleId: null,
          requester: '',
          responsability: null,
          requestDescription: '',
        }
      }

      this.showSendDialog = true
    },

    closeSendDialog() {
      this.showSendDialog = false
      this.osInfo = {
        serviceOrderName: '',
        responsibleId: null,
        requester: '',
        responsability: '',
        requestDescription: '',
      }
    },

    async saveOsInfo() {
      if (!this.osInfo.serviceOrderName) {
        this.$toast.error('Por favor, preencha o nome da OS')
        return
      }
      if (!this.osInfo.responsibleId) {
        this.$toast.error('Por favor, selecione o responsável')
        return
      }
      if (!this.osInfo.responsability) {
        this.$toast.error('Por favor, selecione a responsabilidade')
        return
      }
      if (!this.osInfo.requester) {
        this.$toast.error('Por favor, preencha o solicitante')
        return
      }
      if (!this.osInfo.requestDescription) {
        this.$toast.error('Por favor, preencha a solicitação/reclamação')
        return
      }

      this.sendLoading = true

      try {
        const equipmentIds = this.planningSelected.map((item) => item.id)

        const payload = {
          equipmentIds: equipmentIds,
          osInfo: {
            serviceOrderName: this.osInfo.serviceOrderName,
            responsibleId: this.osInfo.responsibleId,
            requester: this.osInfo.requester,
            responsability: this.osInfo.responsability,
            requestDescription: this.osInfo.requestDescription,
          },
        }

        await this.apiService.post('equipment/planning/os-info', payload)

        this.$toast.success('Informações da OS salvas com sucesso!')

        this.planningSelected.forEach((selectedItem) => {
          const item = this.planningItems.find((i) => i.id === selectedItem.id)
          if (item) {
            item.osInfo = { ...this.osInfo }
          }
        })

        this.closeSendDialog()
        this.planningSelected = []
        this.getPlanningData()
      } catch (error) {
        console.error('Erro ao salvar informações da OS:', error)
        this.$toast.error('Erro ao salvar informações da OS')
      } finally {
        this.sendLoading = false
      }
    },

    showDetails(item) {
      this.selectedItemDetails = item
      this.showDetailsDialog = true
    },

    confirmDeleteOsInfo() {
      if (!this.selectedItemDetails || !this.selectedItemDetails.osInfo) {
        return
      }

      if (confirm('Tem certeza que deseja excluir as informações desta OS?')) {
        this.deleteOsInfo()
      }
    },

    async deleteOsInfo() {
      if (!this.selectedItemDetails || !this.selectedItemDetails.osInfo) {
        return
      }

      this.deleteLoading = true

      try {
        const planningId =
          this.selectedItemDetails.osInfo.planningId ||
          this.selectedItemDetails.id

        await this.apiService.delete(`equipment/planning/os-info/${planningId}`)

        this.$toast.success('Informações da OS excluídas com sucesso!')

        const item = this.planningItems.find(
          (i) => i.id === this.selectedItemDetails.id
        )
        if (item) {
          item.osInfo = null
        }

        this.showDetailsDialog = false
        this.selectedItemDetails = null
        this.getPlanningData()
      } catch (error) {
        console.error('Erro ao excluir informações da OS:')
      } finally {
        this.deleteLoading = false
      }
    },

    getResponsibleName(responsibleId) {
      if (!responsibleId) return '-'
      const responsible = this.responsibles.find((r) => r.id === responsibleId)
      return responsible ? responsible.name : '-'
    },

    getResponsibilityText(responsability) {
      if (!responsability) return '-'

      const resp = responsability.toLowerCase()
      if (resp === 'true' || resp === 'interna') return 'Interna'
      if (resp === 'false' || resp === 'externa') return 'Externa'

      return responsability
    },
  },

  watch: {
    serviceOrderTypeSelected: {
      deep: true,
      handler() {
        this.typeSearch = ''
      },
    },

    standardEquipmentSelected() {
      this.search = ''
    },

    'planningFilter.page': {
      deep: true,
      handler() {
        this.getPlanningData()
      },
    },

    'planningFilter.pageSize': {
      deep: true,
      handler() {
        this.getPlanningData()
      },
    },

    planningStandardEquipmentSelected() {
      this.planningStandardSearch = ''
    },
  },
}
</script>

<style scoped></style>
